import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import OddsDropdownImpl from './odds-dropdown.js';

const { UIView } = MojitoCore.Presentation;

/**
 * Component to display and switch price type for a single bet.
 *
 * @class OddsDropdown
 * @memberof Mojito.Modules.BetslipView.BetComponents
 */

/**
 * OddsDropdown prop types.
 *
 * @property {boolean} [hasOddsChange = false] - Indicates if the bet's odds have changed.
 * @property {Mojito.Services.Betslip.types.Bet} bet - Bet instance.
 * @property {Array<object>} prices - Selection prices.
 * @property {boolean} [suspended = false] - Flag indicating whether the bet is suspended.
 * @property {boolean} [expired = false] - Flag indicating whether the bet is expired.
 *
 * @memberof Mojito.Modules.BetslipView.BetComponents.OddsDropdown
 */
const propTypes = {
    hasOddsChange: PropTypes.bool,
    bet: PropTypes.object.isRequired,
    prices: PropTypes.array.isRequired,
    suspended: PropTypes.bool,
    expired: PropTypes.bool,
};

const defaultProps = {
    hasOddsChange: false,
    suspended: false,
    expired: false,
};

export default UIView('OddsDropdown', OddsDropdownImpl, propTypes, defaultProps);
